<template>
    <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
    <br />

    <div class="col-md-12">
        <div class="card card-primary">
            <div class="card-header">
                <h3 class="card-title" style="color: white">
                    Documentos enviados
                </h3>
            </div>

            <div class="card-body table-responsive p-0">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Tipo doc</th>
                            <th>Obrigatório</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="document in user_documents" :key="document" @click="redirect(document)">
                            <td data-label="Nome">{{ document.nome }}</td>

                            <td data-label="Tipo doc">{{ document.tipodoc }}</td>

                            <td data-label="Obrigatório">{{ convertObrigatorio(document.obrigatorio) }}</td>

                            <td data-label="Status" :style="getStyle(document.verificado)">
                                {{ convertStatus(document.verificado) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</template>
  
<script>
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import useVueLidate from '@vuelidate/core';
import { email, sameAs, helpers }  from '@vuelidate/validators';
import { required } from "../locales/i18n.js";
import { computed, reactive } from "vue";

export default {

    props: ['docs_tipo_usuario', 'user_documents'],

    mixins: [sweetAlert, Swal, AuxController],

    components: { Loading },

    setup() {
        const formData = reactive({
            nome: "",
            documento: "",
        })

        const rules = computed(() => {
            return {
                nome: { required },
                documento: { required },
            }
        })

        const v$ = useVueLidate(rules, formData);

        return { formData, v$ }
    },

    data() {
        return {
            isLoading: false,
            doc_tipo_usuario_selecionado: "",
            upload_files: "",
            aux_docs_tipo_usuario: []
        };
    },

    mounted() {

        //REMOVENDO JÁ ENVIADOS
        for (let i = 0; i < this.docs_tipo_usuario.length; i++) {
            let indice = this.findTipodoc(this.docs_tipo_usuario[i].tipodoc);

            console.log(indice);

            if (indice < 0) {
                this.aux_docs_tipo_usuario.push(this.docs_tipo_usuario[i]);
            }
        }
    },

    methods: {

        redirect(doc) {
            window.location.href = "/admin/user/document/view/" + doc.id;
        },

        findTipodoc(tipodoc) {
            let indice = this.user_documents.findIndex(element => element['tipodoc'] == tipodoc);

            return indice;
        },

        convertStatus(status) {
            if (status == 1) {
                return "Aprovado";
            } else if (status == 2) {
                return "Rejeitado";
            } else {
                return "Aguardando";
            }
        },

        convertObrigatorio(obrigatorio) {
            if (obrigatorio == 1) {
                return "Sim";
            } else {
                return "Não";
            }
        },

        getStyle(status) {
            if (status == 1) {
                return "color: #007d41";
            } else if (status == 2) {
                return "color: red";
            } else {
                "";
            }
        },

        formatDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm:ss");
        },
    },
};
</script>


<style scoped>
tr {
    cursor: pointer
}
</style>
